<template>
  <v-app>
    <v-app-bar app flat clipped-left dense>
      <v-menu v-if="isAuthenticated" transition="slide-y-transition" offset-y bottom>
        <template #activator="{ on }">
          <v-app-bar-nav-icon class="hidden-sm-and-up" v-on="on"> </v-app-bar-nav-icon>
        </template>
        <v-list>
          <v-list-item v-for="item in leftNavMenu" :key="item.title" :to="item.to">
            <v-list-item-content>
              <v-list-item-title
                >{{ item.title
                }}<v-chip v-if="item.chip" color="accent">
                  {{ item.chip }}
                </v-chip></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-toolbar-title>
        <a href="/">
          <img height="50" class="mt-2" src="@/assets/rex-analytics-logo.svg" />
        </a>
      </v-toolbar-title>

      <template v-if="isAuthenticated">
        <v-toolbar-items class="hidden-xs-only">
          <v-btn v-for="item in leftNavMenu" :key="item.title" :to="item.to" exact depressed ripple
            >{{ item.title }}
            <v-chip v-if="item.chip" color="accent">
              {{ item.chip }}
            </v-chip>
          </v-btn>
        </v-toolbar-items>
        <v-spacer />
        <v-btn to="/docs" exact depressed ripple class="mx-1"> API </v-btn>
        <AppMenu />
        <v-btn to="/wiki" exact depressed ripple class="mx-1">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon v-on="on">mdi-help-circle-outline</v-icon>
            </template>
            <span>Wiki</span>
          </v-tooltip>
        </v-btn>
        <v-menu
          v-if="isAuthenticated"
          bottom
          min-width="200px"
          rounded
          offset-y
          :close-on-content-click="false"
        >
          <template #activator="{ on }">
            <v-btn icon v-on="on">
              <v-avatar class="primary white--text" left size="35">
                <img v-if="currentUser.picture" :src="currentUser.picture" />
                <span v-else>
                  {{ currentUser.email.slice(0, 1).toUpperCase() }}
                </span>
              </v-avatar>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content class="justify-center">
              <div class="mx-auto text-center">
                <v-avatar class="primary white--text" color="primary" left>
                  <img v-if="currentUser.picture" :src="currentUser.picture" />
                  <span v-else>
                    {{ currentUser.email.slice(0, 1).toUpperCase() }}
                  </span>
                </v-avatar>
                <p class="text-caption mt-1">
                  {{ currentUser.email }}
                </p>
                <v-divider class="my-3"></v-divider>
                <div v-if="isAcelerex" class="px-4 pb-3" @click.stop>
                  <div class="mb-3">
                    <div class="text-caption text--secondary mb-1">Current Organization</div>
                    <div class="d-flex align-center">
                      <v-icon small color="primary" class="mr-2">mdi-domain</v-icon>
                      <span v-if="currentOrganization" class="text-body-2 font-weight-medium">
                        {{ currentOrganization.name }}
                      </span>
                      <span v-else class="text-body-2 font-italic">Loading</span>
                    </div>
                  </div>
                  <v-autocomplete
                    v-model="organizationSelected"
                    :search-input.sync="organizationSearch"
                    label="Switch"
                    :items="organizations"
                    item-text="name"
                    item-value="id"
                    return-object
                    prepend-inner-icon="mdi-swap-horizontal"
                    append-icon="mdi-content-save"
                    :loading="searchLoading"
                    hide-details
                    outlined
                    dense
                    @click:append="updateOrganization"
                    @click.stop
                  ></v-autocomplete>
                </div>
                <v-btn depressed rounded text @click.stop="logout">
                  <v-icon>mdi-logout</v-icon>
                  Logout
                </v-btn>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
      </template>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer app padless color="secondary">
      <v-row justify="center" dense>
        <v-col class="text-center white--text" cols="12">
          <strong>Acelerex v{{ version }}</strong> &mdash; &copy;2017-{{ currentYear }}
          Acelerex Inc.
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "App",
  components: {
    AppMenu: () => import("@/components/AppMenu.vue"),
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      lastUpdatedCase: null,
      organizationSearch: "",
      organizations: [],
      organizationSelected: null,
      currentOrganization: null,
      searchLoading: false,
      searchTimeout: null,
    };
  },
  computed: {
    ...mapState({
      // getUsername: (state) => (state.auth.user ? state.auth.user.email : null),
      // currentScenarioId: (state) => state.scenarios.currentId,
    }),
    isAuthenticated() {
      return this.$auth.isAuthenticated;
    },
    currentUser() {
      return this.$auth.user;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    isAcelerex() {
      return this.currentUser?.email?.toLowerCase().endsWith("@acelerex.com");
    },
    leftNavMenu() {
      return [];
      // return [
      //   {
      //     title: "Cases",
      //     to: this.directoryOverview,
      //   },
      //   {
      //     title: "Deltas",
      //     to: { name: "ClassicDeltas" },
      //   },
      //   (() => {
      //     // TODO: Use a real feature flag:
      //     // See https://docs.gitlab.com/ee/operations/feature_flags.html
      //     // and https://github.com/Unleash/unleash
      //     const { hostname } = window.location;
      //     return hostname.includes("consulting") ||
      //       hostname.includes("localhost") ||
      //       hostname.includes("demo") ||
      //       hostname.includes("analytics")
      //       ? {
      //           title: "Forecasts",
      //           to: { name: "ClassicForecasts" },
      //         }
      //       : {};
      //   })(),
      // ].filter((e) => e.title != null);
    },
    // directoryOverview() {
    //   const route = {
    //     name: "Folders",
    //   };
    //   if (this.$route.params.folderId) {
    //     route.params = { folderId: this.$route.params.folderId };
    //   }
    //   return route;
    // },
  },
  methods: {
    ...mapActions({ findCase: "cases/find" }),
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
    /**
     * Searches organizations with debouncing for autocomplete dropdown.
     * Supports immediate execution for initial data loading.
     */
    async searchOrganizations(immediate = false) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (this.searchLoading || (!immediate && !this.organizationSearch?.trim())) {
        return;
      }

      const performSearch = async () => {
        this.searchLoading = true;
        try {
          const query = this.organizationSearch?.trim()
            ? { name: { $ilike: `${this.organizationSearch.trim()}%` }, $limit: 10 }
            : { $limit: 10 };

          const result = await this.$store.dispatch("organizations/find", {
            query,
          });
          this.organizations = result.data;
        } catch (error) {
          console.error("Error searching organizations:", error);
        } finally {
          this.searchLoading = false;
        }
      };

      if (immediate) {
        await performSearch();
      } else {
        this.searchTimeout = setTimeout(performSearch, 300);
      }
    },
    /**
     * Persists the selected organization change to the user record.
     * Triggers full page reload to apply new organization context.
     */
    async updateOrganization() {
      if (!this.organizationSelected || !this.currentUser) {
        return;
      }

      try {
        await this.$store.dispatch("users/patch", [
          this.currentUser.id,
          { organization_id: this.organizationSelected.id },
        ]);
        window.location.href = "/";
      } catch (error) {
        console.error("Error updating organization:", error);
      }
    },
    /**
     * Initializes organization data for the current user.
     * Sets organizationSelected immediately to prevent "Loading" state, then loads full data.
     */
    async loadOrganizationData() {
      await this.searchOrganizations(true);

      if (this.currentUser.organization_id) {
        this.organizationSelected = {
          id: this.currentUser.organization_id,
          name: null,
        };

        try {
          const currentOrg = await this.$store.dispatch(
            "organizations/get",
            this.currentUser.organization_id
          );
          this.currentOrganization = currentOrg;
          this.organizationSelected.name = currentOrg.name;
        } catch (error) {
          console.error("Error getting current organization:", error);
        }
      }
    },
  },
  async mounted() {
    if (this.isAcelerex && this.currentUser) {
      await this.loadOrganizationData();
    }
  },
  watch: {
    organizationSearch() {
      this.searchOrganizations();
    },
    async currentUser(newUser, oldUser) {
      // Handle case where auth loads after component mounts
      if (newUser && !oldUser && this.isAcelerex && !this.currentOrganization) {
        await this.loadOrganizationData();
      }
    },
  },
  beforeDestroy() {
    // Clear any pending search timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
};
</script>

<style>
.flex > .v-subheader {
  height: auto;
}

.v-data-table table tbody tr.v-data-table__expanded__content {
  box-shadow: none;
  -webkit-box-shadow: none;
}
</style>
